import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.CREATE_BAG_SIZE.REQUEST, saga.createBagSize);
    yield takeLatest(ACTION.CREATE_BAG_SIZE.SUCCESS, saga.createBagSizeSuccess);
}
